import React from 'react';

interface StarRatingProps {
  stars: {
    full: number;
    half: number;
    empty: number;
    score: number;
  };
  showScore?: boolean;
}

const StarRating: React.FC<StarRatingProps> = ({ stars, showScore = false }) => {
  const FullStar = () => (
    <div className="d-flex align-items-center justify-content-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 19 19">
        <path fill="#FFB605" d="m10 14.844-5.817 3.058 1.111-6.477L.588 6.838l6.504-.945L10 0l2.908 5.893 6.504.945-4.706 4.587 1.111 6.477z"></path>
      </svg>
    </div>
  );

  const HalfStar = () => (
    <div className="d-flex align-items-center justify-content-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 19 19">
        <defs>
          <linearGradient id="half">
            <stop offset="0%" stopColor="#FFB605"></stop>
            <stop offset="50%" stopColor="#FFB605"></stop>
            <stop offset="50%" stopColor="rgb(115,115,115)"></stop>
            <stop offset="100%" stopColor="rgb(115,115,115)"></stop>
          </linearGradient>
        </defs>
        <path fill="url(#half)" d="m10 14.844-5.817 3.058 1.111-6.477L.588 6.838l6.504-.945L10 0l2.908 5.893 6.504.945-4.706 4.587 1.111 6.477z"></path>
      </svg>
    </div>
  );

  const EmptyStar = () => (
    <div className="d-flex align-items-center justify-content-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 19 19">
        <path fill="rgb(115,115,115)" d="m10 14.844-5.817 3.058 1.111-6.477L.588 6.838l6.504-.945L10 0l2.908 5.893 6.504.945-4.706 4.587 1.111 6.477z"></path>
      </svg>
    </div>
  );

  const renderStars = () => {
    const starElements = [];
    
    // Full stars
    for (let i = 0; i < stars.full; i++) {
      starElements.push(<FullStar key={`full-${i}`} />);
    }
    
    // Half star
    if (stars.half > 0) {
      starElements.push(<HalfStar key="half" />);
    }
    
    // Empty stars
    for (let i = 0; i < stars.empty; i++) {
      starElements.push(<EmptyStar key={`empty-${i}`} />);
    }
    
    return starElements;
  };

  return (
    <div className="d-flex align-items-center gap-1">
      <div className="d-flex gap-1">
        {renderStars()}
      </div>
      {showScore && (
        <span className="text-muted small ms-1">
          ({stars.score}/10)
        </span>
      )}
    </div>
  );
};

export default StarRating;